/**
 *
 * WriteOff
 *
 */

import { mapState, mapActions } from 'vuex';
import Swal from 'sweetalert2';

import { getUrlProtocol } from '@/utils/browser';

import TrackerButton from '@/components/TrackerButton.vue';
import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';
import Spinner from '@/components/Spinner.vue';
import {
  SERVER_ROOT_DOMAIN,
  URL_WWW_PZ_ACADEMY_COM,
  URL_CLASS_PZ_ACADEMY_COM,
} from '@/constants/index';
import { DASHBOARD_PAGE } from '@/constants/routes';
import { LOADING_MESSAGE } from '@/scripts/Mall/Order/Order.constants';
import { OrderWriteOffMixin } from '@/scripts/Mall/Order/OrderWriteOff.mixin';

export default {
  name: 'WriteOff',

  mixins: [OrderWriteOffMixin],

  components: {
    SharedHeader,
    SharedFooter,
    Spinner,
    TrackerButton,
  },

  data: () => {
    return {
      URL_WWW_PZ_ACADEMY_COM,
      SERVER_ROOT_DOMAIN,
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Mall/Order', {
      ms_taobaoOrderResult: 'taobaoOrderResult',
    }),

    c_isLogin() {
      return Boolean(this.mg_userInfo.studentId);
    },

    c_isShowSpinner() {
      return this.ms_isRequest;
    },

    c_taobaoCodeStatus() {
      return this.ms_order.taobaoCodeStatus;
    },

    c_taobaoResultMessage() {
      if (undefined !== this.c_taobaoCodeStatus) {
        if (1 === this.c_taobaoCodeStatus) {
          return '开课码已使用';
        } else if (2 === this.c_taobaoCodeStatus) {
          return '开课码已失效';
        } else {
          return this.ms_taobaoOrderResult.message;
        }
      } else {
        return '开课码已失效';
      }
    },

    c_isPayDisabled() {
      return this.ms_isRequest;
    },
  },

  methods: {
    ...mapActions('Mall/Order', {
      //ma_getMallGoodQrcodePayed: 'getMallGoodQrcodePayed',
      ma_getMallPublicGoodQrcode: 'getMallPublicGoodQrcode',
      ma_mallAddForTaobao: 'mallAddForTaobao',
    }),

    //
    getMallGoodQrcode() {
      return this.ma_getMallPublicGoodQrcode({
        goodId: this.c_goodId,
        source: this.$route.query.source,
      });
    },

    addForFreeIfIsLogin() {
      if (this.c_isLogin) {
        this.addForFree();
      } else {
        this.$router.push(`/login?login_redirect_uri=${encodeURIComponent(this.$route.fullPath)}`);
      }
    },

    //
    async addForFree() {
      this.addForFreeStatus = 2;
      try {
        let flagFail = false;
        await this.ma_mallAddForTaobao({
          code: this.c_goodId,
          source: this.ms_order.vendorSource,
        });
        if (false === this.ms_taobaoOrderResult.data) {
          flagFail = true;
        }
        if (!flagFail) {
          this.getStudentAndTutorInfo();
          this.addForFreeStatusNextStep();
        } else {
          this.addForFreeStatus = -1;
        }
      } catch (e) {
        this.addForFreeStatus = -1;
      }
    },

    //
    addForFreeStatusNextStep() {
      this.addForFreeStatus = 1;
    },

    gotoDashboard() {
      this.$router.push(DASHBOARD_PAGE);
    },

    gotoHome() {
      window.location.href = getUrlProtocol() + URL_WWW_PZ_ACADEMY_COM;
    },

    _WriteOffCreated() {
      if (this.c_isMobile || this.c_isWechatBrowser) {
        if (URL_CLASS_PZ_ACADEMY_COM === window.location.host) {
          window.location.href = window.location.href.replace(
            URL_CLASS_PZ_ACADEMY_COM,
            'msite.pzacademy.com'
          );
          return;
        }
      }
      if (this.c_isLogin) {
        this.ma_getUserInfo();
      }
      this.promiseGetMallGoodQrcode = this.getMallGoodQrcode();
      this.setGiftsList();
    },

    async _WriteOffMounted() {
      await this.promiseGetMallGoodQrcode;
      if (this.c_taobaoCodeStatus > 0) {
        this.addForFreeStatus = -1;
      } else if (this.ms_order && this.ms_order.studentBuyLimit) {
        await Swal.fire({
          icon: 'warning',
          backdrop: 'static',
          keyboard: false,
          title: '温馨提示',
          text: this.ms_order.studentBuyLimitMessage,
          confirmButtonColor: '#3085d6',
          confirmButtonText: '确定',
        }).then((result) => {
          if (result.value) {
            window.location.href = 'https://www.pzacademy.com/mall';
          }
        });
      }
    },

    _WriteOffBeforeDestroy() {
      //
    },
  },

  created() {
    this._WriteOffCreated();
  },

  mounted() {
    window.scrollTo(0, 0);
    this._WriteOffMounted();
  },

  beforeDestroy() {
    this._WriteOffBeforeDestroy();
  },
};
